import { defineComponent, computed } from "vue";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Button",
  props: {
    size: { default: void 0 },
    type: { default: void 0 },
    customStyle: { default: () => ({}) },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    round: { type: Boolean, default: true },
    plain: { type: Boolean, default: false }
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    function handleClick(event) {
      if (!props.disabled) {
        emit("click", event);
      }
    }
    const buttonClassList = computed(() => [
      "tui-button",
      `tui-button-${props.type}`,
      `tui-button-${props.size}`,
      { "tui-button-round": props.round },
      { "tui-button-loading": props.loading },
      { "tui-button-disabled": props.disabled },
      { "tui-button-plain": props.plain }
    ]);
    return { __sfc: true, props, emit, handleClick, buttonClassList };
  }
});
export {
  _sfc_main as default
};
